import { Box, Button, Typography } from '@mui/material'

import MeetSensorNbiotLeakImg from '../../images/meet-sensor-nbiot_leak.svg'
import WheresTheCodeImg from '../../images/wheres-the-code.png'

import classes from './index.styles'

const LocateCodeImages = () => (
  <>
    <Box sx={classes.locateCodeSvgWrapper}>
      <img src={MeetSensorNbiotLeakImg} alt="Leak and Freeze sensor" height="95" style={classes.locateCodeSvgImg} />
    </Box>
    <img src={WheresTheCodeImg} alt="Graphic showing where to find the code on your sensor's sticker" height="72" />
  </>
)

interface ActivationInstructionsProps {
  hasNbiotLeak: boolean
  hasLeak5s: boolean
  onLocateCodeClick: () => void
}

const ActivationInstructions = ({ hasNbiotLeak, hasLeak5s, onLocateCodeClick }: ActivationInstructionsProps) => {
  // There are Leak & Freeze devices to activate, but no Slims
  if (hasNbiotLeak && !hasLeak5s) {
    return (
      <>
        <Typography variant="body2" color="secondary">
          Turn over your Leak & Freeze device and locate the code on the sticker. Choose the device that matches this code on the list and complete activation.
        </Typography>

        <Box sx={classes.locateCodeImagesRowCentered}>
          <LocateCodeImages />
        </Box>
      </>
    )
  }

  // There are Slim devices to activate, but no Leak & Freeze
  if (!hasNbiotLeak && hasLeak5s) {
    return (
      <Typography variant="body2" color="secondary">
        Select the sensor you would like to activate from the list below.
      </Typography>
    )
  }

  // There are both Leak & Freeze and Slim devices to activate
  return (
    <Typography variant="body2" color="secondary">
      Select the sensor you would like to activate from the list below. If you are installing a Leak & Freeze sensor,{' '}
      <Button variant="text" color="secondary" onClick={onLocateCodeClick} sx={classes.locateCodeButton}>
        locate the code
      </Button>{' '}
      first before continuing.
    </Typography>
  )
}

export { LocateCodeImages }
export default ActivationInstructions
